import { NotFoundView } from "@/views/common/notfound.view";
import { Route, Switch } from "wouter";
import { MasterdataDashboardView } from "./masterdata-dashboard.view";

export function MasterdataDashboardRoutes() {
  return (
    <Switch>
      <Route path="/" component={MasterdataDashboardView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
